import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { AuthService } from '../services/auth.service';
import { FornecedorService } from '../services/fornecedor.service';
import { ProdutoSaidaService } from '../services/produto-saida.service';
import { ProdutoService } from '../services/produto.service';

import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-produto-saida-edit',
  templateUrl: './produto-saida-edit.component.html',
  styleUrls: ['./produto-saida-edit.component.css'],
  animations: [loadingFade]
})
export class ProdutoSaidaEditComponent implements OnInit {
  public loading;
  public submitting = false;
  public produto_saida_id = null;
  public produtos;
  public fornecedores;
  public codigoProduto = '';
  public href: string = "";
	public hiddenSubmit = false;

  public formSaida: FormGroup;

  // datepickers
  public data_dp;

  //filtro
  public produto_saida_pedido___pedido = null;
  public produto_id___produto = null;
  public fornecedor_id___fornecedor = null;
  public produto_saida_data___data_i = null;
  public produto_saida_data___data_f = null; 

  constructor(private authSvc: AuthService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private router: Router,
    private fornecedorSvc: FornecedorService,
    private produtoSaidaSvc: ProdutoSaidaService,
    private produtoSvc: ProdutoService) { }

  ngOnInit() {

    this.href = this.router.url;
    let path = this.router.url;	
    let pathS = path.split("/"); 

    this.pegaProdutos();
    if(pathS[3] == "ver"){
      this.criaFormDisabled();
      this.hiddenSubmit = true;
    }else{
      this.criaForm();
    }


    this.pegaProdutos();
    this.loading = true;

    this.route.params.subscribe(params => {
      if (params.id) {


        var splitFiltro = params.id.split("?");

				if(splitFiltro[1] !== undefined){
				  
				  var splitfiltro = splitFiltro[1].split("&");
				  for (let f in splitfiltro) {
		
					var loSplitValor = splitfiltro[f].split("=");
		
					switch(loSplitValor[0]) { 
					  case "produto_saida_pedido___pedido": { 
						 this.produto_saida_pedido___pedido = loSplitValor[1];
						 break; 
					  } 
					  case "produto_id___produto": { 
						this.produto_id___produto = parseInt(loSplitValor[1]);
						 break; 
					  } 
					  case "fornecedor_id___fornecedor": { 
              this.fornecedor_id___fornecedor = parseInt(loSplitValor[1]);
               break; 
              }             
					  case "produto_saida_data___data_i": { 
						this.produto_saida_data___data_i = loSplitValor[1];
						 break; 
					  }      
					  case "produto_saida_data___data_f": { 
						this.produto_saida_data___data_f = loSplitValor[1];
						 break; 
					  }      
                                                      
				   }
		
				  }
		
		
				}	

        this.produto_saida_id = params.id;
        // pega dados a partir do id
        this.produtoSaidaSvc.getProdutoSaida(params.id).then((data: any) => {
          let data_saida = null

          if (moment(data.produto_saida_data).isValid()) {
            let moment_date = moment(data.produto_saida_data, 'YYYY-MM-DD');
            data_saida = moment_date.format('DD/MM/YYYY');
						if(pathS[3] != "ver"){
							this.data_dp.setDate(moment_date.toDate());
						}
          }

          this.preencheForm({
            produto_saida_id: data.produto_saida_id,
            usuario_id: this.authSvc.getUsuarioId(),
            unidade_id: data.unidade_id,
            cliente_id: data.cliente_id,
            produto_id: data.produto_id,
            codigoProduto: data.produto.produto_codigo,
            produto_saida_quantidade: data.produto_saida_quantidade,
            produto_saida_data: data_saida,
            produto_saida_pedido: data.produto_saida_pedido,
            produto_saida_valor_unit: data.produto_saida_valor_unit,
            produto_saida_valor_total: data.produto_saida_valor_unit * data.produto_saida_quantidade
          });

          this.loading = false;
        });
      }
      else {
        this.loading = false;
      }
    });
  }

  pegaProdutos() {
    this.produtoSvc.getProdutos().then((data: any) => {
      this.produtos = data;
    }).catch((err) => {
      console.log(err);
    });
  }

  preencheForm(dados) {
    this.formSaida.setValue(dados);
  }

  criaForm() {
    this.formSaida = this.fb.group({
      produto_saida_id: null,
      usuario_id: this.authSvc.getUsuarioId(),
      unidade_id: '',
      cliente_id: '',
      produto_id: [null, Validators.required],
      codigoProduto: '',
      produto_saida_quantidade: [null, Validators.required],
      produto_saida_data: [null, Validators.required],
      produto_saida_pedido: ['', Validators.required],
      produto_saida_valor_unit: ['', Validators.required],
      produto_saida_valor_total: 0

    });

    moment.locale('pt-Br');
    this.data_dp = Datepicker('#produto_saida_data', {
      customMonths: moment.months(),
      customDays: moment.weekdaysShort(),
      overlayPlaceholder: 'Preencha o ano',
      overlayButton: 'Enviar',
      formatter: (element, date) => {
        let formatted = moment(date).format('DD/MM/YYYY');
        this.formSaida.controls['produto_saida_data'].setValue(formatted);
      }
    });
  }



  criaFormDisabled() {
    this.formSaida = this.fb.group({
      produto_saida_id: null,
      usuario_id: {value: null, disabled: true},
      unidade_id: {value: null, disabled: true},
      cliente_id: {value: null, disabled: true},
      produto_id: {value: null, disabled: true},
      codigoProduto: {value: null, disabled: true},
      produto_saida_quantidade: {value: null, disabled: true},
      produto_saida_data: {value: null, disabled: true},
      produto_saida_pedido: {value: null, disabled: true},
      produto_saida_valor_unit: {value: null, disabled: true},
      produto_saida_valor_total: {value: null, disabled: true},

    });
  }

  enviaSaida() {
    if (this.formSaida.valid) {
      this.submitting = true;

      let toSend = this.formSaida.value;
      toSend['produto_saida_data_gravacao'] = moment().format('DD/MM/YYYY');
      if (this.produto_saida_id === null) { // criar
        this.produtoSaidaSvc.criaProdutoSaida(toSend).then((data) => {
          console.log('resp', data);
          Swal.fire({
            type: 'success',
            title: 'Saída cadastrada com sucesso!',
            onClose: () => {
              this.router.navigate(['home/produto-saida']);
            }
          });
        }).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde.'
          });
        });
      }
      else { // editar
        this.produtoSaidaSvc.editaProdutoSaida(toSend).then((data) => {
          console.log('resp', data);
          Swal.fire({
            type: 'success',
            title: 'Entrada alterada com sucesso!',
            onClose: () => {
              this.router.navigate(['home/produto-saida']);
            }
          });
        }).catch(err => {
          console.log(err);
          this.submitting = false;
          Swal.fire({
            type: 'error',
            title: 'Ops! Algo de errado aconteceu!',
            text: 'Tente novamente mais tarde.'
          });
        });
      }
    }
    else {
      for( let field in this.formSaida.controls){
				let campo = this.formSaida.get(field);
				campo.markAsTouched();
			}
      this.submitting = false;
      Swal.fire({
        type: 'error',
        title: 'Atenção!',
        text: 'Verifique os campos obrigatórios e tente novamente.'

      });
    }
  }

  onChangeProduto(e) {
    this.formSaida.controls['codigoProduto'].setValue(e.produto_codigo);
  }

  invalid(nome) {
    let input = this.formSaida.get(nome);
    return input.touched && input.invalid;
  }

  atualizaTotal(){
		this.formSaida.get('produto_saida_valor_total').setValue(this.formSaida.get('produto_saida_quantidade').value * this.formSaida.get('produto_saida_valor_unit').value);
	}

 

	onClickVoltar(){

		let params = 'produto_saida_pedido___pedido=' + this.produto_saida_pedido___pedido;
		params += "&produto_id___produto=" + this.produto_id___produto;
    params += "&fornecedor_id___fornecedor=" + this.fornecedor_id___fornecedor;
		params += "&produto_saida_data___data_i=" + this.produto_saida_data___data_i;
		params += "&produto_saida_data___data_f=" + this.produto_saida_data___data_f;

	
		this.router.navigate(['/home/produto-saidafiltro/' + params]);
	
	  }	  

}
